import EntryBulkActionProvider from "../../providers/entryBulkActionProvider";

export default  function () {
  return window.AppConfig.mergeJson({
    namespaced: true,
    state: {
      provider: <EntryBulkActionProvider> new EntryBulkActionProvider(),
      selectedEntries: [],
      allFilteredEntriesSelected: false,
      allSeenEntriesSelected: false
    },
    mutations: {
      selectEntry(state, entry) {
        state.selectedEntries.push({id: entry.id});
      },
      selectAllFilteredEntries(state){
        state.allFilteredEntriesSelected = true;
      },
      selectAllSeenEntries(state, value = true){
        state.allSeenEntriesSelected = value;
      },
      removeEntryFromSelected(state, entry) {
        state.allFilteredEntriesSelected = false;
        state.allSeenEntriesSelected =false;
        state.selectedEntries = state.selectedEntries.filter(x => x.id !== entry.id);
      },
      clearSelectedEntries(state){
        state.allSeenEntriesSelected =false;
        state.allFilteredEntriesSelected = false;
        state.selectedEntries = [];
      },
    },
    actions: {
      createJob({state, commit}, {listView, action, actionParams, listViewFilterQuery}) {
        let data: any = {
          action_id: action.id,
          action_params: actionParams,
          all_filtered_entries: state.allFilteredEntriesSelected,
        }

        if (state.allFilteredEntriesSelected) {
          data.list_view_filter_query = listViewFilterQuery
        } else {
          data.selected_entry_ids = state.selectedEntries.map(e => e.id)
        }

        return state.provider.create({listView}, data)
      }
    }
  });
}
